import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE,
    GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE,
    ADD_USER_REQUEST, ADD_USER_SUCCESS, ADD_USER_FAILURE,
    EDIT_USER_REQUEST, EDIT_USER_SUCCESS, EDIT_USER_FAILURE,
    DELETE_USER_REQUEST, DELETE_USER_SUCCESS, DELETE_USER_FAILURE,
    SET_ADD_USER_POPUP, SET_EDIT_USER_POPUP, SET_DELETE_USER_POPUP,
    RESET_USER_STATE
} from '../actions/users.action';


export interface User {
    uuid: string;
    firstName: string;
    lastName: string;
    email: string;
    userType: string;
    companyUuid: string;
    teamUuid: string;
}

export interface State {
    users: User[];
    user: User | {};
    loading: boolean;
    error: string | null;
    addUserLoading: boolean;
    editUserLoading: boolean;
    deleteUserLoading: boolean;
    addPopupOpen: boolean;
    editPopupOpen: boolean;
    deletePopupOpen: boolean;

}

const initialState: State = {
    users: [],
    user: {},
    loading: false,
    addUserLoading: false,
    editUserLoading: false,
    deleteUserLoading: false,
    error: null,
    addPopupOpen: false,
    editPopupOpen: false,
    deletePopupOpen: false,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_USERS_SUCCESS:
            return { ...state, users: action.payload, loading: false, error: null };
        case GET_USERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_USER_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_USER_SUCCESS:
            return { ...state, user: action.payload, loading: false, error: null };
        case GET_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ADD_USER_REQUEST:
            return { ...state, addUserLoading: true };
        case ADD_USER_SUCCESS:
            return { ...state, addUserLoading: false };
        case ADD_USER_FAILURE:
            return { ...state, addUserLoading: false };
        case EDIT_USER_REQUEST:
            return { ...state, editUserLoading: true };
        case EDIT_USER_SUCCESS:
            return { ...state, editUserLoading: false };
        case EDIT_USER_FAILURE:
            return { ...state, editUserLoading: false };
        case DELETE_USER_REQUEST:
            return { ...state, deleteUserLoading: true };
        case DELETE_USER_SUCCESS:
            return { ...state, deleteUserLoading: false };
        case DELETE_USER_FAILURE:
            return { ...state, deleteUserLoading: false };
        case SET_ADD_USER_POPUP:
            return { ...state, addPopupOpen: action.payload };
        case SET_EDIT_USER_POPUP:
            return { ...state, editPopupOpen: action.payload };
        case SET_DELETE_USER_POPUP:
            return { ...state, deletePopupOpen: action.payload };
        case RESET_USER_STATE:
            return {...initialState}
        default:
            return state;
    }
};

export default reducer;
